export default {"src":"/_next/static/media/car_64.c29c545e.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};